import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/home/index.vue'),
    hidden: true,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/home/home'),
      },
      {
        path: 'instructions',
        name: 'instructions',
        component: () => import('@/views/home/instructions'),
      },
      {
        path: 'download',
        name: 'download',
        component: () => import('@/views/home/download'),
      },
      {
        path: 'support',
        name: 'support',
        component: () => import('@/views/home/support'),
      },
      {
        path: 'resetPassword',
        name: 'resetPassword',
        component: () => import('@/views/resetPassword/index'),
      },
    ]
  },
]

const createRouter = () => new Router({
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})

const router = createRouter()

export default router
